import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const TutorialContext = createContext(null);

export const TutorialProvider = ({ children }) => {
  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [active, setActive] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [pendingSteps, setPendingSteps] = useState(null);

  const startTutorial = useCallback((tutorialSteps) => {
    if (blocked) {
      setPendingSteps(tutorialSteps);
      return;
    }
    setSteps(tutorialSteps);
    setCurrentStep(0);
    setActive(true);
  }, [blocked]);

  // When unblocked, drain any queued tutorial
  useEffect(() => {
    if (!blocked && pendingSteps) {
      setSteps(pendingSteps);
      setCurrentStep(0);
      setActive(true);
      setPendingSteps(null);
    }
  }, [blocked, pendingSteps]);

  const nextStep = useCallback(() => {
    setCurrentStep((prev) => {
      if (prev + 1 >= steps.length) {
        setActive(false);
        return 0;
      }
      return prev + 1;
    });
  }, [steps.length]);

  const closeTutorial = useCallback(() => {
    setActive(false);
    setCurrentStep(0);
  }, []);

  return (
    <TutorialContext.Provider
      value={{ active, steps, currentStep, startTutorial, nextStep, closeTutorial, setBlocked }}
    >
      {children}
    </TutorialContext.Provider>
  );
};

export const useTutorial = () => {
  const ctx = useContext(TutorialContext);
  if (!ctx) throw new Error("useTutorial must be inside TutorialProvider");
  return ctx;
};
